function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import Link from "../Link";
import Typography from "../Typography";
import Tooltip from "../Tooltip";
const renderLabel = (label, maxLength, overflowPostFix) => {
  if (maxLength && overflowPostFix && label.length > maxLength) {
    const label_cut = label.substring(0, maxLength - overflowPostFix) + '...' + label.slice(-overflowPostFix);
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: label
    }, /*#__PURE__*/React.createElement("span", null, label_cut));
  } else if (maxLength && label.length > maxLength) {
    const label_cut = label.substring(0, maxLength) + '...';
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: label
    }, /*#__PURE__*/React.createElement("span", null, label_cut));
  } else {
    return label;
  }
};
const BreadcrumbItem = _ref => {
  let {
    href = null,
    label,
    variant,
    maxLength = 30,
    overflowPostFix,
    color = "inherit",
    onClick,
    ...restProps
  } = _ref;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement(React.Fragment, null, href ? /*#__PURE__*/React.createElement(Link, _extends({
      underline: "hover",
      variant: "overline",
      color: variant && variant === 'primaryLink' ? 'primary' : color,
      style: variant && variant === 'primaryLink' && {
        fontWeight: 'normal'
      },
      href: href,
      onClick: onClick
    }, restProps), renderLabel(label, maxLength, overflowPostFix)) : /*#__PURE__*/React.createElement(Typography, _extends({
      color: variant && variant === 'primaryLink' ? 'primary' : color,
      variant: "overline",
      "aria-label": label,
      onClick: onClick
    }, restProps), renderLabel(label, maxLength, overflowPostFix)))
  );
};
export default BreadcrumbItem;